import { Flex, Image } from "@chakra-ui/react";
import Heading from "./Heading";

export default function GitHubStats(){
    return (
        <Flex padding={"5"} direction={"column"} alignItems={"center"} gap={"20"} marginTop={"50px"}>
            <Heading
             text={`My GitHub Stats`}
             size="lg"
            />
        <Image id="github-streak-stats" src="https://github-readme-streak-stats.herokuapp.com?user=Abhishree-codes&theme=midnight-purple&border_radius=40)](https://git.io/streak-stats"/>
        <Image id="github-stats-card" src="https://github-readme-stats.vercel.app/api?username=Abhishree-codes&show_icons=true&theme=midnight-purple"/>
        <Image id="github-top-langs" src="https://github-readme-stats.vercel.app/api/top-langs/?username=Abhishree-codes&show_icons=true&theme=midnight-purple"/>
        </Flex>
    )
}